import React from 'react';
import { createBrowserRouter, useRouteError } from 'react-router-dom';
import {
  ConstructionSites,
  ConstructionSiteDetail,
  ConstructionSiteView,
} from './modules/construction';
import { Dashboard, Setting } from './modules/general';
import { Template, Templates, TemplatesManageItems } from './modules/templates';
import {
  PurchaseOrderTemplate,
  PurchaseOrderTemplates,
} from './modules/purchase-order-templates';
import { PurchaseOrder, PurchaseOrders } from './modules/purchase-orders';
import { Customers } from './modules/customers';
import Suppliers from './modules/supplier/Suppliers';
// import SupplierDetail from './modules/supplier/components/SupplierDetail';
import SuggestedValueCategories from './modules/suggested-value';
import Leads from './modules/leads/Leads';
import { Quotes } from './modules/quotes';
import LogItems from './modules/log-items/LogItems';
import Cars from './modules/cars/Cars';
import { Employees } from './modules/employees';
import Timesheets from './modules/timesheets/Timesheets';
import NewTimesheet from './modules/timesheets/components/NewTimesheet';
import Architects from './modules/architects/Architects';
import CustomerPaymentTransactions from './modules/payment-transaction/CustomerPaymentTransactions';
import CustomerInvoices from './modules/customer-invoice/CustomerInvoice';
import { WorkOrders } from './modules/work-orders';
import CustomerContractUpdates from './modules/customer-contract-update/CustomerContractUpdates';
import IncomingInvoices from './modules/incoming-invoice/IncomingInvoice';
import CostCenters from './modules/cost-center/CostCenters';
import PrivateRoute from './utils/PrivateRoute';
import { SalesReps } from './modules/sales-reps';

function replaceWithBr(text: string) {
  return text.replace(/\n/g, '<br />');
}

function ErrorBoundary() {
  const error: any = useRouteError();
  console.error(error);
  /* appInsights.trackException({
    severityLevel: SeverityLevel.Error,
    exception: typeof error === 'string' ? new Error(error) : error,
  }); */
  // Uncaught ReferenceError: path is not defined
  return (
    <div>
      <h2>Er ging iets mis.</h2>
      <p>
        <strong>{error.message}</strong>
      </p>
      <p
        dangerouslySetInnerHTML={{ __html: replaceWithBr(error.stack) }}
        style={{ fontSize: '12px' }}
      />
    </div>
  );
}

const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <PrivateRoute>
        <ConstructionSites />
      </PrivateRoute>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/start',
    element: (
      <PrivateRoute>
        <Dashboard />
      </PrivateRoute>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/employees',
    element: (
      <PrivateRoute permission='read:employees'>
        <Employees />
      </PrivateRoute>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/sales-reps',
    element: (
      <PrivateRoute permission='read:employees'>
        <SalesReps />
      </PrivateRoute>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/construction-sites/',
    element: (
      <PrivateRoute permission='read:constructionSites'>
        <ConstructionSites />
      </PrivateRoute>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/construction-sites/add',
    element: (
      <PrivateRoute permission='read:constructionSites'>
        <ConstructionSiteView />
      </PrivateRoute>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/construction-sites/:id/:view',
    element: (
      <PrivateRoute permission='read:constructionSites'>
        <ConstructionSiteDetail />
      </PrivateRoute>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/construction-sites/:id',
    element: (
      <PrivateRoute permission='read:constructionSites'>
        <ConstructionSites />
      </PrivateRoute>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/templates',
    element: (
      <PrivateRoute permission='read:templates'>
        <Templates />
      </PrivateRoute>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/template/:id',
    element: (
      <PrivateRoute permission='read:templates'>
        <Template />
      </PrivateRoute>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/templates/manage-items',
    element: (
      <PrivateRoute permission='read:templates'>
        <TemplatesManageItems />
      </PrivateRoute>
    ),
  },
  {
    path: '/purchase-order/:id',
    element: (
      <PrivateRoute permission='read:purchaseOrders'>
        <PurchaseOrder />
      </PrivateRoute>
    ),
  },
  {
    path: '/purchase-order-template/:id',
    element: (
      <PrivateRoute permission='read:purchaseOrderTemplates'>
        <PurchaseOrderTemplate />
      </PrivateRoute>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/purchase-order-templates',
    element: (
      <PrivateRoute permission='read:purchaseOrderTemplates'>
        <PurchaseOrderTemplates />
      </PrivateRoute>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/purchase-orders',
    element: (
      <PrivateRoute permission='read:purchaseOrders'>
        <PurchaseOrders />
      </PrivateRoute>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/customers',
    element: (
      <PrivateRoute permission='read:customers'>
        <Customers />
      </PrivateRoute>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/leads',
    element: (
      <PrivateRoute permission='read:leads'>
        <Leads />
      </PrivateRoute>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/cars',
    element: (
      <PrivateRoute permission='read:cars'>
        <Cars />
      </PrivateRoute>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/quotes',
    element: (
      <PrivateRoute permission='read:quoteReferences'>
        <Quotes />
      </PrivateRoute>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/log-items',
    element: (
      <PrivateRoute permission='read:logItems'>
        <LogItems />
      </PrivateRoute>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/suppliers',
    element: (
      <PrivateRoute permission='read:suppliers'>
        <Suppliers />
      </PrivateRoute>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/timesheets',
    element: (
      <PrivateRoute permission='read:timeSheetEntries'>
        <Timesheets />
      </PrivateRoute>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/new-timesheet',
    element: (
      <PrivateRoute permission='read:timeSheetEntries'>
        <NewTimesheet />
      </PrivateRoute>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/architects',
    element: (
      <PrivateRoute permission='read:architects'>
        <Architects />
      </PrivateRoute>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/payment-transactions',
    element: (
      <PrivateRoute permission='read:customerPaymentTransactions'>
        <CustomerPaymentTransactions />
      </PrivateRoute>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/payment-transactions/:id',
    element: (
      <PrivateRoute permission='read:customerPaymentTransactions'>
        <CustomerPaymentTransactions />
      </PrivateRoute>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/customer-invoices',
    element: (
      <PrivateRoute permission='read:customerInvoices'>
        <CustomerInvoices />
      </PrivateRoute>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/incoming-invoices',
    element: (
      <PrivateRoute permission='read:incomingInvoices'>
        <IncomingInvoices />
      </PrivateRoute>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/work-orders',
    element: (
      <PrivateRoute permission='read:defectWorkOrders'>
        <WorkOrders />
      </PrivateRoute>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/contract-updates',
    element: (
      <PrivateRoute permission='read:customerContractUpdates'>
        <CustomerContractUpdates />
      </PrivateRoute>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/cost-centers',
    element: (
      <PrivateRoute permission='read:costCenters'>
        <CostCenters />
      </PrivateRoute>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/suggested-values',
    element: (
      <PrivateRoute permission='read:suggestedValueCategories'>
        <SuggestedValueCategories />
      </PrivateRoute>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/settings',
    element: (
      <PrivateRoute permission='read:suggestedValueCategories'>
        <Setting />
      </PrivateRoute>
    ),
    errorElement: <ErrorBoundary />,
  },
]);

export default router;
